import { render } from "./MasterHeader.vue?vue&type=template&id=37587f5a&scoped=true"
import script from "./MasterHeader.vue?vue&type=script&lang=js"
export * from "./MasterHeader.vue?vue&type=script&lang=js"

import "./MasterHeader.vue?vue&type=style&index=0&id=37587f5a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37587f5a"]])

export default __exports__